<template>
  <!-- ==================== FILTER DRAWER ==================== -->
  <div class="filter-drawer-bg"></div>
  <div class="filter-drawer" data-nosnippet>
    <div class="filter-header">
      <h2>Filters</h2>
      <h5>Filters</h5>
      <span class="closer" @click="closeDrawer()">x</span>
    </div>
    <!-- .filter-header -->
     <div v-if="isLoading" class="loading loading--plp-filters">
      <!-- <LoadingAnimation /> -->
       <span></span>
    </div>
    <div v-else class="filter-overflower">
      <div class="filters">
        <!-- ==================== FILTERS NEW ==================== -->
        <div
          class="filter-group"
          v-for="filter in filters"
          :key="filter.filterId"
          :class="{ active: activeFilterDrawer === filter.filterId }"
        >
          <CheckboxFilter
            v-if="filter.filterType === 'checkbox'"
            :filter="filter"
            @open="(filterId) => openFilter(filterId)"
          />
          <ColorFilter
            v-else-if="filter.filterType === 'color'"
            :filter="filter"
            @open="(filterId) => openFilter(filterId)"
          />
          <PriceFilter
            v-else-if="filter.filterType === 'price'"
            :filter="filter"
            @open="(filterId) => openFilter(filterId)"
            @price-change="updatePriceRange"
            :minPrice="minPrice"
            :maxPrice="maxPrice"
            :initialPriceRange="initialPriceRange"
            ref="priceFilter"
          />
        </div>
        <!-- .filter-group -->
      </div>
      <!-- filters -->
    </div>
    <!-- .filter-overflower -->
    <div class="results">
      <a class="clear-all" v-if="filtersActive" @click="clearFilters()"
        >Clear All</a
      >
      <a class="btn btn-default" @click="closeDrawer()"
        >View {{ filteredProducts.length }} Results</a
      >
    </div>
    <!-- .results -->
  </div>
  <!-- filter-drawer -->
</template>
<script src="./ctrl-collection-filters.js"></script>
